import React, { useState, useEffect } from 'react';
import { AiFillLinkedin } from 'react-icons/ai';
import { motion } from 'framer-motion';

import { AppWrap, MotionWrap } from '../../wrapper';
import { urlFor, client } from '../../client';
import './TeamMember.scss';

const TeamMember = () => {
  const [teamMembers, setTeamMembers] = useState([]);
  const [filterTeamMember, setFilterTeamMember] = useState([]);
  const [activeFilter, setActiveFilter] = useState('All');
  const [animateCard, setAnimateCard] = useState({ y: 0, opacity: 1 });

  useEffect(() => {
    const query = '*[_type == "teamMembers"]';

    client.fetch(query).then((data) => {
      setTeamMembers(data);
      setFilterTeamMember(data);
    });
  }, []);

  const handleTeamMemberFilter = (item) => {
    setActiveFilter(item);
    setAnimateCard([{ y: 100, opacity: 0 }]);

    setTimeout(() => {
      setAnimateCard([{ y: 0, opacity: 1 }]);

      if (item === 'All') {
        setFilterTeamMember(teamMembers);
      } else {
        setFilterTeamMember(teamMembers.filter((teamMember) => teamMember.tags.includes(item)));
      }
    }, 500);
  };

  return (
    <>
      <h2 className="head-text">Our <span>Team</span></h2>

      <div className="app__teamMember-filter">
        {['IT', 'Media', 'Leadership', 'All'].map((item, index) => (
          <div
            key={index}
            onClick={() => handleTeamMemberFilter(item)}
            className={`app__teamMember-filter-item app__flex p-text ${activeFilter === item ? 'item-active' : ''}`}
          >
            {item}
          </div>
        ))}
      </div>

      <motion.div
        animate={animateCard}
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        className="app__teamMember-portfolio"
      >
        {filterTeamMember.map((teamMember, index) => (
          <div className="app__teamMember-item app__flex" key={index}>
            <div
              className="app__teamMember-img app__flex"
            >
              <img src={urlFor(teamMember.imgUrl)} alt={teamMember.name} />

              <motion.div
                whileHover={{ opacity: [0, 1] }}
                transition={{ duration: 0.25, ease: 'easeInOut', staggerChildren: 0.5 }}
                className="app__teamMember-hover app__flex"
              >
                <a href={teamMember.linkedinLink} target="_blank" rel="noreferrer">
                  <motion.div
                    whileInView={{ scale: [0, 1] }}
                    whileHover={{ scale: [1, 0.90] }}
                    transition={{ duration: 0.25 }}
                    className="app__flex"
                  >
                    <AiFillLinkedin />
                  </motion.div>
                </a>
              </motion.div>
            </div>

            <div className="app__teamMember-content app__flex">
              <h4 className="bold-text">{teamMember.title}</h4>
              <p className="p-text" style={{ marginTop: 10 }}>{teamMember.description}</p>

              <div className="app__teamMember-tag app__flex">
                <p className="p-text">{teamMember.tags[0]}</p>
              </div>
            </div>
          </div>
        ))}
      </motion.div>
    </>
  );
};

export default AppWrap(
  MotionWrap(TeamMember, 'app__teamMembers'),
  'Our Team',
  'app__primarybg',
);
